import { Blockquote, Button, Group, Stack, TextInput } from "@mantine/core"
import { UseFormReturnType } from "@mantine/form"
import {
  IconArrowLeft,
  IconArrowRight,
  IconInfoCircle,
} from "@tabler/icons-react"

import { BQDatasourceFormData } from "@costory/types/endpoints/metricsDatasources"

import { useUser } from "@costory/front/components/auth/UserContext"
import { runtimeConfig } from "@costory/front/lib/runtimeConfig"

export const BigQueryConfiguration = ({
  form,
  handleClickBack,
  handleClickNext,
}: {
  form: UseFormReturnType<BQDatasourceFormData>
  handleClickBack: () => void
  handleClickNext: () => void
}) => {
  const user = useUser()
  const dataProjectId = runtimeConfig.VITE_DATA_PROJECT_ID

  return (
    <Stack justify="space-between" h="100%">
      <Stack gap="md">
        <Blockquote color="blue" icon={<IconInfoCircle />} mt="xl">
          Share your Bigquery Dataset with costory-
          {user.currentOrg.slug}@{dataProjectId}.iam.gserviceaccount.com:
        </Blockquote>
        <TextInput
          label="BigQuery Table Path"
          {...form.getInputProps("bqUri")}
          autoComplete="on"
          data-intercom-target="costory-tour-datasource-bigquery-uri-input"
        />
      </Stack>
      <Group justify="space-between" pb={20}>
        <Button
          onClick={handleClickBack}
          variant="outline"
          leftSection={<IconArrowLeft />}
          data-intercom-target="costory-tour-datasource-bigquery-back-button"
        >
          Back
        </Button>
        <Button
          onClick={handleClickNext}
          rightSection={<IconArrowRight />}
          disabled={!form.getValues().bqUri}
          data-intercom-target="costory-tour-datasource-bigquery-next-button"
        >
          Next
        </Button>
      </Group>
    </Stack>
  )
}
